export default function useLocalStorage(key: string) {
  const value = JSON.parse(globalThis.localStorage.getItem(key) ?? 'null');

  const set = (newValue: any) => {
    globalThis.localStorage.setItem(key, JSON.stringify(newValue));
  };

  return [value, set];
}
